import { useContext, useEffect } from 'react';
import { SwitchThemeContext, useViewport } from '@tryhackme/thm-ui-components';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { TaskType } from 'src/common/enums/task';
import { ThemeColorMode } from 'src/common/enums';
import { AccordionDetails as TaskDescription } from '../../tasks/components/accordion-details';
import { QuestionAndAnswerSection } from '../..';
import { useResetUserProgressMutation, useTerminateVmMutation } from '../../../room.slice';
import { StyledLoading, StyledLoadingWrapper, StyledRoomContentWrapper } from './room-content.styles';
import { RoomContentProps } from './room-content.types';
import { TaskContentButton } from './task-content-button';
export const RoomContent = ({
  currentTask,
  isLastTask,
  joinRoom,
  hasUserJoinedRoom,
  attackBoxPrivateIP,
  autoAnswerQuestions,
  machineIP,
  activeMachine,
  advanceToNextTask,
  roomDetails,
  ...taskDescriptionProps
}: RoomContentProps) => {
  const {
    roomCode
  } = taskDescriptionProps;
  const {
    width
  } = useViewport();
  const [terminateVM] = useTerminateVmMutation();
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDarkMode = theme === ThemeColorMode.DARK;
  const isTaskWithVM = currentTask ? [TaskType.VM, TaskType.THM].includes(currentTask.type) : false;
  const [, {
    isLoading: isResetRoomProgressLoading
  }] = useResetUserProgressMutation({
    fixedCacheKey: 'shared-reset-progress'
  });
  useEffect(() => {
    if (currentTask && !isTaskWithVM && activeMachine) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      terminateVM(activeMachine.id);
    }
  }, [activeMachine, isTaskWithVM, terminateVM, currentTask]);
  if (!currentTask || !roomDetails || isResetRoomProgressLoading) {
    return <StyledLoadingWrapper>
        <StyledLoading />
        <StyledLoading />
        <StyledLoading />
      </StyledLoadingWrapper>;
  }
  const {
    _id: taskId,
    type,
    taskNo,
    description,
    title,
    uploadId,
    questions = []
  } = currentTask;
  const isTaskComplete = currentTask.questions.every(question => question.progress?.correct);
  const shouldSeeVmStart = !!hasUserJoinedRoom && width > BREAKPOINTS.MOBILE && isTaskWithVM;
  return <StyledRoomContentWrapper $isDark={isDarkMode} key={taskNo} data-sentry-element="StyledRoomContentWrapper" data-sentry-component="RoomContent" data-sentry-source-file="room-content.tsx">
      <TaskDescription {...taskDescriptionProps} taskType={type} description={description} title={title} taskNo={taskNo} isTaskBreakdownSupported shouldSeeVmStart={shouldSeeVmStart} taskId={taskId} data-sentry-element="TaskDescription" data-sentry-source-file="room-content.tsx" />
      <TaskContentButton roomCode={roomCode} taskId={taskId} taskNo={taskNo} uploadId={uploadId} roomId={roomDetails._id} taskType={type} currentTask={currentTask} activeMachine={activeMachine} shouldSeeVmStart={shouldSeeVmStart} data-sentry-element="TaskContentButton" data-sentry-source-file="room-content.tsx" />
      <QuestionAndAnswerSection questions={questions} roomCode={roomCode} roomType={roomDetails.type} taskId={taskId} taskNo={taskNo} joinRoom={joinRoom} hasUserJoinedRoom={hasUserJoinedRoom} isTaskComplete={isTaskComplete} machineIP={machineIP} attackBoxPrivateIP={attackBoxPrivateIP} autoAnswerQuestions={autoAnswerQuestions} advanceToNextTask={advanceToNextTask} isTaskBreakdownSupported isLastTask={isLastTask} data-sentry-element="QuestionAndAnswerSection" data-sentry-source-file="room-content.tsx" />
    </StyledRoomContentWrapper>;
};